export default {
  countrySelectorLabel: "Country code",
  countrySelectorError: "Choose country",
  countrySelectorSearchPlaceholder: "Search country",
  phoneNumberLabel: "Phone number",
  example: "Example:",
};
